class MHeader extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      headers: ["header"],
      logos: [".m-logo"],
      topbar: ".m-topbar",
      headerWrapper: ".m-header__wrapper",
      topbarClose: ".m-topbar__close",
    };
    this.domNodes = queryDomNodes(this.selectors, this);
    this.innerWidth = window.innerWidth;
    this.headerOffsetTop = this.domNodes.headerWrapper.offsetTop;
    this.headerHeight = this.domNodes.headerWrapper.offsetHeight;
    this.stickyHeader = this.dataset.sticky;

    this.classes = {
      scrollUp: "scroll-up",
      scrollDown: "scroll-down",
      stuck: "stuck",
      always: "header-sticky-always",
      headerScrollUp: "header-scroll-up",
      headerScrollDown: "header-scroll-down",
    };
    this.init();
  }

  init() {
    this.transparentHeader =
      this.domNodes && this.domNodes.headers[0] && this.domNodes.headers[0].dataset.transparent === "true";
    this.initAddon();
    this.initMenuBadges();
    this.handleSticky();
    document.addEventListener("matchMobile", () => this.handleSticky());
    document.addEventListener("unmatchMobile", () => this.handleSticky());
    this.siteNav = new SiteNav(this);
    window.__sfHeader = this;
    window.addEventListener("resize", () => {
      this.innerWidth = window.innerWidth;
    });
  }

  initAddon() {
    this.megamenu = new Megamenu(this);
    if (Shopify.designMode) {
      MinimogTheme = MinimogTheme || {};
      MinimogTheme && MinimogTheme.Wishlist && MinimogTheme.Wishlist.updateWishlistCount();
    }
  }
  handleSticky() {
    let extraSpace = 20;
    const sectionGroups = document.querySelectorAll(".shopify-section-group-header-group");
    sectionGroups.forEach((section) => {
      if (!section.classList.contains("m-section-header") && !section.classList.contains("m-section-scaling-logo")) {
        extraSpace += section.offsetHeight;
      }
    });
    const topBar = document.querySelector(".m-topbar");
    if (topBar) extraSpace += topBar.offsetHeight;

    let lastScroll = 0;
    window.addEventListener("scroll", () => {
      const currentScroll = window.scrollY;
      if (currentScroll <= extraSpace) {
        this.classList.remove(this.classes.scrollUp, this.classes.stuck, this.classes.always);
        document.body.classList.remove(this.classes.headerScrollUp, this.classes.headerScrollDown);
        return;
      }

      if (this.stickyHeader === "on_scroll_up") {
        this.classList.add(this.classes.stuck);
      } else if (this.stickyHeader === "always") {
        this.classList.add(this.classes.always);
      }

      if (
        currentScroll > this.headerHeight + extraSpace &&
        currentScroll > lastScroll &&
        !this.classList.contains(this.classes.scrollDown)
      ) {
        this.classList.remove(this.classes.scrollUp);
        document.body.classList.remove(this.classes.headerScrollUp);
        this.classList.add(this.classes.scrollDown);
        document.body.classList.add(this.classes.headerScrollDown);
      } else if (currentScroll < lastScroll && this.classList.contains(this.classes.scrollDown)) {
        this.classList.remove(this.classes.scrollDown);
        document.body.classList.remove(this.classes.headerScrollDown);
        this.classList.add(this.classes.scrollUp);
        document.body.classList.add(this.classes.headerScrollUp);
      }
      lastScroll = currentScroll;
    });
  }

 /*
  ============================================
  HÀM MỚI: TÌM VÀ TẠO BADGE CHO MENU (DESKTOP & MOBILE)
  ============================================
  */
  initMenuBadges() {
    // Tìm link menu trong cả desktop VÀ mobile drawer
    // '.m-menu-mobile__link' là class thường dùng cho link mobile trong theme này
    const menuLinks = this.querySelectorAll(
      '.m-header__desktop .m-menu__link, #m-menu-drawer .m-menu-mobile__link' 
    );

    // Định nghĩa các loại badge và class tương ứng
    const badgeMap = {
      '[NEW]': 'new',
      '[HOT]': 'hot',
      '[new]': 'new', // Hỗ trợ cả chữ thường
      '[hot]': 'hot'  // Hỗ trợ cả chữ thường
    };

    menuLinks.forEach(link => {
      // Bỏ qua nếu link này đã được xử lý (tránh lỗi lặp lại)
      if (link.dataset.badgeProcessed) return; 

      let linkHTML = link.innerHTML; // Lấy HTML hiện tại của link
      let badgeCreated = false;

      // Vòng lặp qua các loại badge
      for (const tag in badgeMap) {
        // Chỉ tìm tag trong phần text, bỏ qua các thẻ con (như icon arrow)
        const textContent = link.textContent; 

        if (textContent && textContent.includes(tag)) {
          // 1. Xóa tag [NEW] hoặc [HOT] khỏi text node bên trong link
          // Phải duyệt qua các text node để xóa chính xác
          link.childNodes.forEach(node => {
            if (node.nodeType === Node.TEXT_NODE && node.textContent.includes(tag)) {
              node.textContent = node.textContent.replace(tag, '').trim();
            }
          });

          // 2. Lấy tên class (vd: 'new' hoặc 'hot')
          const badgeClass = badgeMap[tag];

          // 3. Tạo thẻ span cho badge
          const badgeElement = document.createElement('span');
          badgeElement.classList.add('m-menu__badge', `m-menu__badge--${badgeClass}`);

          // 4. Lấy text cho badge (vd: "NEW" hoặc "HOT")
          const badgeText = tag.replace('[', '').replace(']', '').toUpperCase();
          badgeElement.textContent = badgeText;

          // 5. Gắn thẻ badge vào cuối link <a>
          // (Trong mobile, thường badge nằm trong link sẽ ổn hơn)
           link.appendChild(badgeElement); 
           // Nếu bạn vẫn muốn badge nằm ngoài <li> cho mobile,
           // bạn cần inspect cấu trúc HTML mobile và điều chỉnh lại logic appendChild tương tự desktop.
           // Nhưng thường thì nằm trong link <a> là đủ.

          badgeCreated = true;
          link.dataset.badgeProcessed = true; // Đánh dấu đã xử lý
          break; // Đã tìm thấy, dừng lại
        }
      }
    });
  }
}
customElements.define("m-header", MHeader);
